module.exports = __webpack_public_path__ + "img/SES_500420012.4f0fd5c5.jpg";